/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAggregateForProfileId } from '../fn/data-mart-profiles/get-aggregate-for-profile-id';
import { GetAggregateForProfileId$Params } from '../fn/data-mart-profiles/get-aggregate-for-profile-id';
import { ProfileAggregate } from '../models/profile-aggregate';

@Injectable({ providedIn: 'root' })
export class DataMartProfilesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `profileAggregateControllerGetAggregateForProfileId()` */
  static readonly ProfileAggregateControllerGetAggregateForProfileIdPath =
    '/data-mart/profiles/{profileId}/aggregate/{programPeriodId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAggregateForProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregateForProfileId$Response(
    params: GetAggregateForProfileId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProfileAggregate>> {
    return getAggregateForProfileId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAggregateForProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAggregateForProfileId(
    params: GetAggregateForProfileId$Params,
    context?: HttpContext
  ): Observable<ProfileAggregate> {
    return this.getAggregateForProfileId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAggregate>): ProfileAggregate => r.body)
    );
  }
}
